import { motion } from "framer-motion";
import "../styles/promo.css";
function PromoHeader() {
    const movingTextVariants = {
        initial: { x: '100vw' }, 
        animate: { x: '-150%' }, 
    };

    const transition = {
        duration: 20, 
        ease: "linear", 
        repeat: Infinity, 
    };
    return ( 
        <div className="movingtextContainer">
                <motion.p 
                    className="movingText"
                    variants={movingTextVariants}
                    initial="initial"
                    animate="animate"
                    transition= {{...transition}}
                    > 
                    Season Special Raffle to win Iphone Pro 17 and Airpods Pro 3 !
                </motion.p>   
        </div>
     );
}

export default PromoHeader;